module.exports = __webpack_public_path__ + "27db006114459c13f2e13c6ad5300281.png";